import { Storage } from '../interfaces/storage.interface';

const COOKIE_EXPIRE = 3 * 24 * 60 * 60 * 1000;

export class CookieStorage implements Storage {

  getItem(key: string): any {
    const cookieArray: Array<string> = document.cookie.split(';');
    const cookieLength: number = cookieArray.length;
    const cookieKey = key + '=';
    let i: number;

    for (i = 0; i < cookieLength; i++) {
      let currentItem = cookieArray[i];
      currentItem = currentItem.trim();
      if (currentItem.indexOf(cookieKey) === 0) {
        return currentItem.substring(cookieKey.length, currentItem.length);
      }
    }
    return '';
  }

  setItem(key: string, value: any): void {
    const d: Date = new Date();
    d.setTime(d.getTime() + COOKIE_EXPIRE); // store cookies for 3 days
    const expires: string = 'expires=' + d.toUTCString();
    document.cookie = key + '=' + value + ';' + expires + ';';
  }

  removeItem(key: string): void {
    this.setItem(key, '');
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/models/cookie-storage.model.ts